(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * Provides an interface to the Watershed API which is necessarily aware
   * of the current user and organization.
   */
  factory('Demo', ['$location', '$rootScope', '$timeout', function ($location, $rootScope, $timeout) {
    return {
      _isDemoMode: false,
      demoModeChangeEvent: 'demo-mode-changed',
      isDemoMode: function isDemoMode() {
        return this._isDemoMode;
      },
      setDemoMode: function setDemoMode(demoMode) {
        this._isDemoMode = !!demoMode;
        $rootScope.$emit(this.demoModeChangeEvent, this._isDemoMode);
      },
      startDemo: function startDemo(cfg) {
        cfg = cfg || {};
        $timeout(function () {
          $rootScope.$emit('demo-tour', cfg);
        });
        if ($location.path() !== '/dashboard/demo') {
          $location.path('/dashboard/demo').search('explorerPreview', null);
        }
      }
    };
  }]);
})();
